import { useEffect } from "react";

const PAGE_BACKGROUND = "rgb(var(--color-page))";

export function usePageBackground(): void {
  useEffect(() => {
    const previous = document.body.style.backgroundColor;
    document.body.style.setProperty("background-color", PAGE_BACKGROUND);
    return () => {
      document.body.style.backgroundColor = previous;
    };
  }, []);
}
